/* tslint:disable */
export const cn_overrides_strings = {
};
